import { createTestIds } from '../../utils';

export const getToasterTestIds = createTestIds('toaster', ['toast'] as const);
